import React from 'react';

/**
 * Kickass Course logo — renders the official PNG (transparent background, gold + dark).
 * Size variants tuned for the new brand mark. Default `md` is intentionally larger
 * than the old default so the brand is unmistakable in the header.
 */
export const Logo = ({ size = 'md', invert = false, withTagline = false }) => {
  const h =
    size === 'xl' ? 'h-20 md:h-24'
    : size === 'lg' ? 'h-16 md:h-20'
    : size === 'sm' ? 'h-10'
    : 'h-12 md:h-16'; // md (default) — visibly larger than before
  return (
    <div className={`inline-flex items-center gap-2 ${invert ? 'kc-logo-invert' : ''}`} data-testid="logo">
      <img
        src="/splash/logo.png"
        alt="Kickass Course"
        className={`${h} w-auto block select-none`}
        draggable="false"
      />
      {withTagline && (
        <span className={`hidden md:block ml-2 text-[10px] tracking-[0.32em] uppercase ${invert ? 'text-white/70' : 'text-muted-kc'}`}>Unleash your full potential</span>
      )}
      <style>{`.kc-logo-invert img { filter: brightness(0) invert(1); }`}</style>
    </div>
  );
};
